import gsap from 'gsap'
import Prefix from 'prefix'

import Magnetic from 'Scripts/components/Magnetic'
import Dropdown from 'Scripts/components/Dropdown'
import Button from 'Scripts/components/Button'
import Theme from 'Scripts/components/Theme'
import Animation from 'Scripts/components/Animation'
import Modal from 'Scripts/components/Modal'
import Filter from 'Scripts/components/Filter'
import Pagination from 'Scripts/components/Pagination'
import Accordion from 'Scripts/components/Accordion'

export default class Page {
  constructor(page, { container, elements, customScroller }) {
    this.page = page
    this.container = container
    this.customScroller = customScroller || null
    this.elements = {}
    // this.customScroller = customScroller
    this.selectors = {
      header: '#header',
      footer: '.footer',
      wrapper: '.site__Container',
      ...elements,
    }
    // console.log(this.elements)
    // this.template = document.querySelector('body').dataset.page
    // this.theme = document.querySelector('body').dataset.theme
    // this.color = document.querySelector('body').dataset.color

    this.transformPrefix = Prefix('transform')
    this.scroll = {
      ease: 0.07,
      position: 0,
      current: 0,
      target: 0,
      limit: 0,
    }

    this.screen = {
      width: window.innerWidth,
      height: window.innerHeight,
    }
    //Methods
    this.create()
  }

  create() {
    this.pageNode =
      this.container instanceof HTMLElement
        ? this.container
        : document.querySelector(this.container)

    for (const [key, selector] of Object.entries(this.selectors)) {
      if (selector instanceof HTMLElement || selector instanceof NodeList) {
        this.elements[key] = selector
      } else {
        this.elements[key] = document.querySelectorAll(selector)
        if (this.elements[key].length === 1) {
          this.elements[key] = document.querySelector(selector)
        } else if (this.elements[key].length === 0) {
          this.elements[key] = null
        }
      }
    }

    // this.scroll = {
    //   ease: 0.07,
    //   position: 0,
    //   current: 0,
    //   target: 0,
    //   limit: this.elements.wrapper.clientHeight - window.innerHeight
    // }
    //Init Components
    this.createComponents()
    // this.addEventListeners()
  }

  createComponents() {
    //Magnetic
    new Magnetic({ selector: '.magnetic' })
    //DropDown
    new Dropdown({ selector: '.dropdown' })
    //Button
    new Button({ selector: '.btn' })
    //Theme : Dark/Light
    new Theme({ selector: '[data-theme-update]' })
    //Modal
    this.initModal()
    //Filters
    new Filter()
    //Pagination
    this.initPagination()
    //Accordion
    new Accordion({ selector: '.accordion' })
  }

  initModal() {
    new Modal({ selector: '[data-modal]' })
  }

  initPagination() {
    this.elements.paginationLink &&
      new Pagination(this.elements.paginationLink, this.elements.moduleWrapper).change(1)
  }

  show() {
    // this.reset()
    this.isVisible = true
    //
    this.textAnimation = new Animation({ selector: '[data-animation]' })
    this.imageAnimation = new Animation({ selector: '[data-scroll]' })
    // console.log('show : ' + this.page)
  }

  hide() {
    this.isVisible = false
    // console.log('hide')
  }

  onResize() {
    this.screen = {
      width: window.innerWidth,
      height: window.innerHeight,
    }
  }

  onMouseWheel(event) {
    const { deltaY } = event
    // console.log(event, deltaY)
    this.scroll.target += deltaY
  }
  /**
   * Listeners.
   */
  addEventListeners() {
    // window.addEventListener('mousewheel', this.onMouseWheel.bind(this))
    // window.addEventListener('wheel', this.onMouseWheel.bind(this))
  }

  removeEventListeners() {
    // window.removeEventListener('mousewheel', this.onMouseWheel.bind(this))
    // window.removeEventListener('wheel', this.onMouseWheel.bind(this))
  }

  reset() {
    this.scroll = {
      ease: 0.07,
      position: 0,
      current: 0,
      target: 0,
      limit: 0,
    }
  }

  update() {
    this.scroll.target = gsap.utils.clamp(0, this.scroll.limit, this.scroll.target)
    this.scroll.current = gsap.utils.interpolate(
      this.scroll.current,
      this.scroll.target,
      this.scroll.ease
    )
    this.scroll.current = Math.floor(this.scroll.current)

    if (this.scroll.current < 0.1) {
      this.scroll.current = 0
    }

    if (this.elements.wrapper) {
      // this.transform(this.elements.wrapper, this.scroll.current)

      this.elements.wrapper.style[this.transformPrefix] = `translate3d(0, ${-Math.round(
        this.scroll.current
      )}px, 0)`
    }

    this.scroll.last = this.scroll.current
  }
}
